import { Component, OnInit, ViewChild } from '@angular/core';
import { SwMassageBoxService } from '../../../../librarys/serves/sw-massage-box.service';
import { KmsService } from '../../kms.service';
import { Router } from '@angular/router';
import { SwMassageConfirmComponent } from '../../../../librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
declare var $;
@Component({
    selector: 'app-knowledge-recycle',
    templateUrl: './knowledge-recycle.component.html',
    styleUrls: ['./knowledge-recycle.component.css']
})
export class KnowledgeRecycleComponent implements OnInit {
    // 头部实体搜索名称
    instanceName = '';

    // 表格实体数据
    instanceDatas = [];

    // 表格是否显示加载中
    isLoading: boolean = false;

    // 表格分页组件
    pageBase:any = {
        current: 1,
        size: 10
    };

    // 表格选中行数据
    selectTableDatas = [];

    // 表格操作按钮
    toolbar = [
        { status: true, functionCode: 'reduction', functionName: '批量还原', icon: 'glyphicon glyphicon-share-alt', children: [] },
        { status: true, functionCode: 'delete', functionName: '批量删除', icon: 'glyphicon glyphicon-trash', children: [] },
    ];

    // 删除确认组件
    @ViewChild("tirm1") tirm1: SwMassageConfirmComponent;
    constructor(
        private kmsService: KmsService,
        private message: SwMassageBoxService,
        private router: Router
    ) { }

    ngOnInit() {
        this.getInstanceListDatas();
    }

    // 获取实体表格列表数据
    getInstanceListDatas() {
        this.isLoading = true;
        let params = {
            current: this.pageBase.current,
            size: this.pageBase.size,
            instanceName: $.trim(this.instanceName)
        };
        this.kmsService.getInstanceRecycleList(params).subscribe(
            result => {
                if (result.code == 200) {
                    this.isLoading = false;
                    this.instanceDatas = [];
                    this.pageBase = result.data;
                    this.instanceDatas = result.data.records;
                } else {
                    this.message.waring(result.msg);
                }
            }
        );
    }

    // 监听输入框enter键搜索
    handelEnterSearch(event) {
        if (event.keyCode == 13) {
            this.getInstanceListDatas();
        }
    }

    // 头部搜索查询方法
    handleSelectClick() {
        this.getInstanceListDatas();
    }

    // 表格按钮点击事件
    handleOperationClick(event) {
        switch (event) {
            case "reduction": this.handleReductionClick(); break; // 还原
            case "delete": this.handleDeleteClick(); break;  // 删除
        }
    }

    // 还原实体
    handleReductionClick() {
        let params = [];
        if (this.selectTableDatas.length > 0) {
            for (let i = 0; i < this.selectTableDatas.length; i++) {
                params.push(this.selectTableDatas[i].instanceId);
            }
        } else {
            this.message.info('请选择要还原的实体数据！');
            return;
        }
        this.kmsService.updateInstanceByIdRecycle(params).subscribe(
            result => {
                if (result.code == 200) {
                    this.message.success('数据还原成功！请前往实体管理页面查看相关内容。');
                    this.getInstanceListDatas();
                    // 根据实体标识删除索引记录
                    this.deleteIndexByInstanceId(0,params,0);
                }
            }
        )
    }

    // 查看实体
    handleViewClick(data) {
        let selectData = {
            instanceId: data.instanceId,
            conceptId: data.conceptId,
            conceptName: data.conceptName
        };
        this.router.navigate(
            ['/kms/InstanceView'],
            { queryParams: { Title: '查看实体信息', selectData: JSON.stringify(selectData) } }
        );
    }

    // 删除实体
    handleDeleteClick(item?) {
        let params = [];
        if (item) {
            params = [item.instanceId];
        } else {
            if (this.selectTableDatas.length > 0) {
                for (let i = 0; i < this.selectTableDatas.length; i++) {
                    params.push(this.selectTableDatas[i].instanceId);
                }
            } else {
                this.message.info('请选择要删除的实体数据！');
                return;
            }
        }
        this.tirm1.openCLick('确认删除吗？', (data) => {
            if (data) {
                this.kmsService.deleteInstanceByIdRecycle(params).subscribe(
                    result => {
                        if (result.code == 200) {
                            this.message.success('数据删除成功！');
                            this.getInstanceListDatas();
                            // 根据实体标识删除索引记录
                            this.deleteIndexByInstanceId(1,params,1);
                        }else{
                            this.message.waring(result.msg);
                        }
                    }
                )
            }
        })
    }

    // 根据实体标识删除索引记录
    deleteIndexByInstanceId(delteType,ids,isDelete){
        let params = {
            "deleteType": delteType,    // 删除类型: 0 逻辑删除 1 物理删除
            "ids": ids,
            "isDelete": isDelete       // 是否删除: 1 删除 0 不删除
        }
        this.kmsService.deleteIndexByInstanceId(params).subscribe(
            result => {
                if (result.code != 200) {
                    console.log('删除索引失败！');
                }
            }
        )
    }

    // 表格选中数据
    handleSelectData(event) {
        this.selectTableDatas = event;
    }

    // 表格分页
    handlePageClick(event) {
        this.pageBase = event;
        this.getInstanceListDatas();
    }
 
}
